import { Controller } from '@hotwired/stimulus';
import { createRoot } from 'react-dom/client';

import { getReactApp } from '../apps';
import { TestTrackProvider } from '../hooks/useFeatureFlag';
import { testTrackPromise } from '../testTrack';

export default class extends Controller {
  connect() {
    const App = getReactApp(this.name);
    const root = createRoot(this.element);
    root.render(
      <TestTrackProvider value={testTrackPromise}>
        <App {...this.initialProps} />
      </TestTrackProvider>
    );
  }

  get name(): string {
    return this.data.get('name')!;
  }

  get initialProps() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(this.data.get('initial-props')!);
  }

  get isRendered() {
    return this.data.get('rendered') === 'true';
  }

  markAsRendered() {
    this.data.set('rendered', 'true');
  }
}
